// @flow
import Modal from "./Modal";
import { fetchHtml, post } from "../../../lib/Fetching";

export default class ClientSpecificationModal extends Modal {
  componentDidMount() {
    const { id } = this.props;
    fetchHtml("/products/client_specifications/" + id, {
      xhr: true
    }).then(body => {
      this.setState({ loaded: true, html: body });
    });
  }
}
